import { useHandleException } from '~/composables/useHandleException'

export const useIntercomCom = (options: { enabled: boolean, widgetId: string | null }) => {
  if (!options?.enabled) {
    return
  }

  if (!options?.widgetId) {
    useHandleException(new Error('Intercom integration: widget id is missing'))

    return
  }

  useHead({
    script: [
      {
        innerHTML: `window.intercomSettings={app_id:'${options.widgetId}'}; (function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/${options.widgetId}';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();`,
        id: 'intercom',
        tagPosition: 'bodyClose',
      },
    ],
  })
}
